export default {"src":"/_next/static/media/google-icon.d92067ee.svg","height":20,"width":20};